// components/Impact.jsx
import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";

function Impact() {
  const { t } = useTranslation();
  const { ref, inView } = useInView({
    triggerOnce: true, // Animate only once
    threshold: 0.3, // Trigger when 30% of section is visible
  });

  const impacts = [
    {
      title: t("impact.emergency.title"),
      value: 10000,
      description: t("impact.emergency.description"),
    },
    {
      title: t("impact.education.title"),
      value: 5000,
      description: t("impact.education.description"),
    },
    {
      title: t("impact.healthcare.title"),
      value: 3000,
      description: t("impact.healthcare.description"),
    },
    {
      title: t("impact.foodSecurity.title"),
      value: 4000,
      description: t("impact.foodSecurity.description"),
    },
    {
      title: t("impact.wash.title"),
      value: 8000,
      description: t("impact.wash.description"),
    },
    {
      title: t("impact.childWelfare.title"),
      value: 1200,
      description: t("impact.childWelfare.description"),
    },
  ];

  return (
    <section ref={ref} id="impact" className="py-16 px-6 bg-gray-50">
      <div className="mx-auto text-center mb-12">
        <h2 className="text-3xl title uppercase font-bold text-primary">
          {t("impact.title")}
        </h2>
        <p className="text-gray-700 mt-2">{t("impact.subtitle")}</p>
      </div>

      <div className=" mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {impacts.map((impact, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow p-6 flex flex-col items-center text-center hover:shadow-lg transition"
          >
            <h3 className="text-3xl title font-bold text-green-800 mb-2">
              {inView ? (
                <CountUp end={impact.value} duration={2} separator="," />
              ) : (
                "0"
              )}
              +
            </h3>
            <h4 className="text-xl font-semibold text-gray-800 mb-2">
              {impact.title}
            </h4>
            <p className="text-gray-700">{impact.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Impact;
